import React, { useState } from 'react'

import styles from "./styles/Accordian.module.scss"
import { FaChevronDown } from 'react-icons/fa'

export default function Accordian({ header = <></>, content = <></>,classes='' }) {
    const [active, setActive] = useState(false);


    return (
        <div className={`${styles.Accordian} ${active ? styles.active : ""} ${classes}`} onClick={() => setActive(prev => !prev)}>
            <div className={styles.header}>
                {header}
                <span className={styles.icon}>
                    <FaChevronDown size={25} color='white' />
                </span>
            </div>
            <div className={styles.content}>
                {content}
            </div>
        </div>
    )
}
